export default function VobsControlPanel() {
  return null;
}
